module.exports = __webpack_public_path__ + "img/mail.c8be503.svg";